import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import pt from 'vuetify/es5/locale/pt';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    dark: false,
    themes: {
      light: {
        background: '#ffffff',
        background_execution: '#503075',
        primary: '#503075',
        secondary: '#784DAA',
        tertiary: '#AFCA11',
        accent: '#503075',
        quarternary: '#FFFFFF',  
        error: '#E43F32',
        warning: '#FFB800',
        info: '#3484A9',
        success: '#4caf50',
      },
      dark: {
        background: "#503075",
        background_execution: "#000000",
        primary: "#503075",
        secondary: "#9F7BCA",
        tertiary: "#AFCA11",
        accent: "#AFCA11",
        quarternary: '#FFFFFF',
        error: '#E43F32',
        warning: '#FFB800',
        info: '#3484A9',
        success: '#4caf50',
      }
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  icons: {
    iconfont: 'mdi',
  },
});
